module.exports = __webpack_public_path__ + "img/container-5.6c8959ad.png";